export default {
  history: {
    none: 'プレイ履歴はありません',
    title: 'HISTORY',
    subtitle: 'プレイ履歴',
    answers: '謎解き解説のご案内'
  }
};
